// County records arrive in capitals; show them in normal case. The original stays in the evidence.
const keep = new Set(['LLC', 'LP', 'LLP', 'PLLC', 'PA', 'PC', 'NA', 'USA', 'PO', 'NOC', 'II', 'III', 'IV', 'N', 'S', 'E', 'W', 'NE', 'NW', 'SE', 'SW']);
const small = new Set(['OF', 'THE', 'AND', 'FOR', 'TO', 'AT', 'BY', 'IN', 'ON']);
export function displayCase(text: string): string {
  if (!/[A-Z]{2}/.test(text) || text !== text.toUpperCase()) return text;
  const words = text.split(/(\s+)/);
  return words.map((word, index) => {
    const bare = word.replace(/[^A-Z]/g, '');
    // A two-letter code followed by a ZIP is a state.
    const next = words.slice(index + 1).find(w => w.trim());
    if (keep.has(bare) || /\d/.test(word) || (bare.length === 2 && /^\d{5}/.test(next ?? ''))) return word;
    if (index > 0 && small.has(bare)) return word.toLowerCase();
    return word.toLowerCase().replace(/(^|[-'/(])([a-z])/g, (_, lead: string, letter: string) => lead + letter.toUpperCase());
  }).join('');
}
